export interface AuthInitialState {
  user: any;
  isAuthenticated: boolean;
  companyDetails: any;
  kioskSettings: any;
}

export const authState: AuthInitialState = {
  user: null,
  isAuthenticated: false,
  companyDetails: null,
  kioskSettings: null,
};
